// extracted by mini-css-extract-plugin
module.exports =  {"productImage":"snZGnM","productBadge":"msLx8J","badge":"E_QZr8","defaultImage":"jT3OGs"};